<template>
    <footer class="c-footer">
        <div class="c-footer-inner">
            <div class="o-wrapper o-wrapper--center">
                <div class="o-auto-grid o-auto-grid--medium">
                    <div>
                        <router-link to="/"><img class="[ c-logo ]" src="/static/logo-bottom-zwarte-achtergrond.svg" width="170px" height="79px"/></router-link>
                        <p>{{ $t('intro.footer') }}</p>
                        <div class="o-gutter o-gutter-tiny">
                            <a href="https://www.facebook.com/highdemandbrands">
                                <svgicon name="facebook"></svgicon>
                            </a>
                            <a href="https://www.instagram.com/highdemandbrands/">
                                <svgicon name="instagram"></svgicon>
                            </a>
                        </div>
                    </div>
                    <div>
                        <span class="c-footer__title u-h5">{{ $t('footer.contact_us') }}</span>
                        <ul class="c-nav">
                            <li>
                                <a href="tel:003213670101" class="c-icon-label">
                                    <svgicon name="phone"></svgicon>
                                    <span>+32(0)13/67.01.01</span>
                                </a>
                            </li>
                            <li>
                                <a href="mailto:info@highdemandbrands.eu" class="c-icon-label">
                                    <svgicon name="mail"></svgicon>
                                    <span>info@highdemandbrands.eu</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <span class="c-footer__title u-h5">{{ $t('footer.customer_zone') }}</span>
                        <ul class="c-nav">
                            <li><router-link to="/customer/account/edit">{{ $t('footer.my_details') }}</router-link></li>
                            <li v-if="isCustomer || isMarketing"><router-link to="/customer/account/history">{{ $t('footer.order_history') }}</router-link></li>
                            <li v-if="isCustomer || isMarketing || isPersoneel"><router-link to="/warranty">{{ $t('footer.returns_and_warranties') }}</router-link></li>
                            <li v-if="isCustomer"><router-link to="/customer/account/users">{{ $t('footer.user_management') }}</router-link></li>
                        </ul>
                    </div>
                    <div>
                        <span class="c-footer__title u-h5">High Demand Brands</span>
                        <ul class="c-nav">
                            <li><a :href="$t('footer_links.about_us')" target="_blank">{{ $t('footer.about') }}</a></li>
                            <li><router-link to="/customer/our-brands">{{ $t('footer.our_brands') }}</router-link></li>
                            <li><a :href="$t('footer_links.blog')" target="_blank">{{ $t('footer.blog_and_news') }}</a></li>
                            <li><a :href="$t('footer_links.vacancies')" target="_blank">{{ $t('footer.vacancies') }}</a></li>
                            <li><router-link to="/contact">{{ $t('footer.contact') }}</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-footer-bottom o-wrapper o-wrapper--center">
            <span>© 2018 High Demand Brands</span>
            <nav>
                <ul class="c-nav c-nav--horizontal o-spacing">
                    <li><a :href="$t('footer_links.privacy')">Privacy</a></li>
                    <li><a href="https://shop.highdemandbrands.eu">Disclaimer</a></li>
                    <li><a :href="$t('footer_links.cookie_policy')">Cookie policy</a></li>
                </ul>
            </nav>
        </div>
    </footer>
</template>

<script>
    export default {
        computed: {
            isAdmin() {
                return this.$store.getters.isAdmin;
            },
            isSalesman() {
                return this.$store.getters.isSalesman;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        }
    }
</script>

<style lang="scss" scoped>

    // Import private settings & functions
    @import "~@/assets/scss/private";

    .c-footer {
        @include rfs($font-size-small);

        @include down($desktop) {
            .o-auto-grid > *:first-child {
                flex: 1 1 100%;
            }
        }
    }

    .c-footer-inner {
        color: white;
        padding: em($global-spacing-unit-medium) 0;
        background-color: $color-base;

        a {
            text-decoration: none;
            font-weight: $normal;
            @include e-link--semi-white();
        }
    }

    .c-footer__title {
        display: block;
        margin-bottom: em($global-spacing-unit-small);
    }

    .c-footer-bottom {
        padding: em($global-spacing-unit) 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }

</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue